import { E_SIGN_CONTRACTS, E_SIGN_TEMPLATES } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const contractsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getContracts: build.query({
      query: (params = {}) => ({
        url: E_SIGN_CONTRACTS.LIST,
        method: 'GET',
        params,
      }),
      providesTags: (result) => listTags('Contract', result),
    }),
    getContractById: build.query({
      query: (id) => ({ url: E_SIGN_CONTRACTS.BY_ID(id), method: 'GET' }),
      providesTags: (_r, _e, id) => [{ type: 'Contract', id }],
    }),
    createContract: build.mutation({
      query: (payload) => {
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: E_SIGN_CONTRACTS.CREATE,
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: 'Contract', id: 'LIST' }],
    }),
    resendContract: build.mutation({
      query: ({ id, signerApiId }) => ({
        url: E_SIGN_CONTRACTS.RESEND(id, signerApiId),
        method: 'POST',
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Contract', id },
        { type: 'Contract', id: 'LIST' },
      ],
    }),
    downloadContract: build.mutation({
      query: ({ id, signPageUrl }) => ({
        url: E_SIGN_CONTRACTS.DOWNLOAD(id, signPageUrl),
        method: 'GET',
        responseType: 'blob',
      }),
    }),
    downloadSignedContractPdf: build.mutation({
      query: (id) => ({
        url: E_SIGN_CONTRACTS.SIGNED_PDF(id),
        method: 'GET',
        responseType: 'blob',
      }),
    }),
    getSignUrl: build.query({
      query: (id) => ({ url: E_SIGN_CONTRACTS.SIGN_URL(id), method: 'GET' }),
      providesTags: (_r, _e, id) => [{ type: 'Contract', id: `sign-${id}` }],
    }),
    getESignTemplates: build.query({
      query: (params = {}) => ({
        url: E_SIGN_TEMPLATES.LIST,
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Contract', id: 'TEMPLATES' }],
    }),
  }),
});

export const {
  useGetContractsQuery,
  useLazyGetContractsQuery,
  useGetContractByIdQuery,
  useLazyGetContractByIdQuery,
  useCreateContractMutation,
  useResendContractMutation,
  useDownloadContractMutation,
  useDownloadSignedContractPdfMutation,
  useGetSignUrlQuery,
  useLazyGetSignUrlQuery,
  useGetESignTemplatesQuery,
  useLazyGetESignTemplatesQuery,
} = contractsApi;
